// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"80960c24","247":"a763af22","422":"a8f87740","627":"6e97d686","653":"4512614e","867":"bbd3c8d4","923":"51f24648","938":"a2ce45d5"}[chunkId] + ".chunk.js";
};